import PorscheInterAutoSvg from 'src/assets/images/porsche-inter-auto.svg';
import styled from 'styled-components';

export const PorscheInterAuto = styled(PorscheInterAutoSvg)`
  height: 0.875rem;
  width: 4.25rem;
`;
